module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eifit"))).then(() => parcelRequire('5erN3'));